import React from 'react';

import DialogActions from '@mui/material/DialogActions';

import StickyPaper from 'components/StickyPaper';

function MenuItemModalFooter({ ...rest }) {
  return (
    <StickyPaper>
      <DialogActions disableSpacing>
        <React.Fragment {...rest} />
      </DialogActions>
    </StickyPaper>
  );
}

export default MenuItemModalFooter;
